import React, { useState, useEffect } from 'react';

const Settings = () => {
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState('general');
  const [settings, setSettings] = useState({
    // Общие настройки
    restaurant_name: 'PWA Menu',
    restaurant_description: 'Лучший ресторан в городе',
    phone: '+7 (999) 123-45-67',
    email: 'info@pwamenu.ru',
    address: 'г. Москва, ул. Примерная, д. 1',
    working_hours: '10:00 - 22:00',
    
    // Настройки доставки
    delivery_enabled: true,
    delivery_fee: 200,
    free_delivery_threshold: 1000,
    delivery_radius: 10,
    delivery_time: 60,
    
    // Настройки оплаты
    cash_payment: true,
    card_payment: true,
    online_payment: true,
    
    // Уведомления
    email_notifications: true,
    sms_notifications: false,
    push_notifications: true,
    
    // Внешний вид
    primary_color: '#091C36',
    secondary_color: '#FCD66F',
    logo_url: '',
  });

  const tabs = [
    { id: 'general', name: 'Общие', icon: '🏪' },
    { id: 'delivery', name: 'Доставка', icon: '🚚' },
    { id: 'payment', name: 'Оплата', icon: '💳' },
    { id: 'notifications', name: 'Уведомления', icon: '🔔' },
    { id: 'appearance', name: 'Внешний вид', icon: '🎨' },
  ];

  useEffect(() => {
    loadSettings();
  }, []);

  const loadSettings = async () => {
    try {
      setLoading(true);
      // В реальном проекте здесь будет вызов API
      // const response = await adminApiService.getEstablishmentSettings();
      // setSettings(response);
    } catch (error) {
      console.error('Ошибка загрузки настроек:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async () => {
    try {
      setLoading(true);
      // В реальном проекте здесь будет вызов API
      // await adminApiService.updateEstablishmentSettings(1, settings);
      alert('Настройки сохранены!');
    } catch (error) {
      console.error('Ошибка сохранения настроек:', error);
      alert('Ошибка сохранения настроек');
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (field, value) => {
    setSettings(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const renderGeneralSettings = () => (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Название ресторана
          </label>
          <input
            type="text"
            className="input-field"
            value={settings.restaurant_name}
            onChange={(e) => handleInputChange('restaurant_name', e.target.value)}
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Телефон
          </label>
          <input
            type="tel"
            className="input-field"
            value={settings.phone}
            onChange={(e) => handleInputChange('phone', e.target.value)}
          />
        </div>
      </div>
      
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Описание ресторана
        </label>
        <textarea
          rows={3}
          className="input-field"
          value={settings.restaurant_description}
          onChange={(e) => handleInputChange('restaurant_description', e.target.value)}
        />
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Email
          </label>
          <input
            type="email"
            className="input-field"
            value={settings.email}
            onChange={(e) => handleInputChange('email', e.target.value)}
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Часы работы
          </label>
          <input
            type="text"
            className="input-field"
            value={settings.working_hours}
            onChange={(e) => handleInputChange('working_hours', e.target.value)}
          />
        </div>
      </div>
      
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Адрес
        </label>
        <input
          type="text"
          className="input-field"
          value={settings.address}
          onChange={(e) => handleInputChange('address', e.target.value)}
        />
      </div>
    </div>
  );

  const renderDeliverySettings = () => (
    <div className="space-y-6">
      <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
        <div>
          <h3 className="font-medium text-gray-900">Включить доставку</h3>
          <p className="text-sm text-gray-600">Разрешить клиентам заказывать доставку</p>
        </div>
        <label className="relative inline-flex items-center cursor-pointer">
          <input
            type="checkbox"
            className="sr-only peer"
            checked={settings.delivery_enabled}
            onChange={(e) => handleInputChange('delivery_enabled', e.target.checked)}
          />
          <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-primary-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-primary-600"></div>
        </label>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Стоимость доставки (₽)
          </label>
          <input
            type="number"
            min="0"
            className="input-field"
            value={settings.delivery_fee}
            onChange={(e) => handleInputChange('delivery_fee', parseInt(e.target.value))}
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Бесплатная доставка от (₽)
          </label>
          <input
            type="number"
            min="0"
            className="input-field"
            value={settings.free_delivery_threshold}
            onChange={(e) => handleInputChange('free_delivery_threshold', parseInt(e.target.value))}
          />
        </div>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Радиус доставки (км)
          </label>
          <input
            type="number"
            min="1"
            max="50"
            className="input-field"
            value={settings.delivery_radius}
            onChange={(e) => handleInputChange('delivery_radius', parseInt(e.target.value))}
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Время доставки (мин)
          </label>
          <input
            type="number"
            min="15"
            max="180"
            className="input-field"
            value={settings.delivery_time}
            onChange={(e) => handleInputChange('delivery_time', parseInt(e.target.value))}
          />
        </div>
      </div>
    </div>
  );

  const renderPaymentSettings = () => (
    <div className="space-y-6">
      <h3 className="text-lg font-medium text-gray-900">Способы оплаты</h3>
      
      <div className="space-y-4">
        <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
          <div className="flex items-center space-x-3">
            <span className="text-2xl">💵</span>
            <div>
              <h4 className="font-medium text-gray-900">Наличными курьеру</h4>
              <p className="text-sm text-gray-600">Оплата при получении заказа</p>
            </div>
          </div>
          <label className="relative inline-flex items-center cursor-pointer">
            <input
              type="checkbox"
              className="sr-only peer"
              checked={settings.cash_payment}
              onChange={(e) => handleInputChange('cash_payment', e.target.checked)}
            />
            <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-primary-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-primary-600"></div>
          </label>
        </div>
        
        <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
          <div className="flex items-center space-x-3">
            <span className="text-2xl">💳</span>
            <div>
              <h4 className="font-medium text-gray-900">Картой курьеру</h4>
              <p className="text-sm text-gray-600">Оплата картой при получении</p>
            </div>
          </div>
          <label className="relative inline-flex items-center cursor-pointer">
            <input
              type="checkbox"
              className="sr-only peer"
              checked={settings.card_payment}
              onChange={(e) => handleInputChange('card_payment', e.target.checked)}
            />
            <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-primary-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-primary-600"></div>
          </label>
        </div>
        
        <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
          <div className="flex items-center space-x-3">
            <span className="text-2xl">🌐</span>
            <div>
              <h4 className="font-medium text-gray-900">Онлайн оплата</h4>
              <p className="text-sm text-gray-600">Оплата через интернет</p>
            </div>
          </div>
          <label className="relative inline-flex items-center cursor-pointer">
            <input
              type="checkbox"
              className="sr-only peer"
              checked={settings.online_payment}
              onChange={(e) => handleInputChange('online_payment', e.target.checked)}
            />
            <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-primary-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-primary-600"></div>
          </label>
        </div>
      </div>
    </div>
  );

  const renderNotificationSettings = () => (
    <div className="space-y-6">
      <h3 className="text-lg font-medium text-gray-900">Уведомления</h3>
      
      <div className="space-y-4">
        <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
          <div className="flex items-center space-x-3">
            <span className="text-2xl">📧</span>
            <div>
              <h4 className="font-medium text-gray-900">Email уведомления</h4>
              <p className="text-sm text-gray-600">Получать уведомления на email</p>
            </div>
          </div>
          <label className="relative inline-flex items-center cursor-pointer">
            <input
              type="checkbox"
              className="sr-only peer"
              checked={settings.email_notifications}
              onChange={(e) => handleInputChange('email_notifications', e.target.checked)}
            />
            <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-primary-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-primary-600"></div>
          </label>
        </div>
        
        <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
          <div className="flex items-center space-x-3">
            <span className="text-2xl">📱</span>
            <div>
              <h4 className="font-medium text-gray-900">SMS уведомления</h4>
              <p className="text-sm text-gray-600">Получать SMS о новых заказах</p>
            </div>
          </div>
          <label className="relative inline-flex items-center cursor-pointer">
            <input
              type="checkbox"
              className="sr-only peer"
              checked={settings.sms_notifications}
              onChange={(e) => handleInputChange('sms_notifications', e.target.checked)}
            />
            <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-primary-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-primary-600"></div>
          </label>
        </div>
        
        <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
          <div className="flex items-center space-x-3">
            <span className="text-2xl">🔔</span>
            <div>
              <h4 className="font-medium text-gray-900">Push уведомления</h4>
              <p className="text-sm text-gray-600">Уведомления в браузере</p>
            </div>
          </div>
          <label className="relative inline-flex items-center cursor-pointer">
            <input
              type="checkbox"
              className="sr-only peer"
              checked={settings.push_notifications}
              onChange={(e) => handleInputChange('push_notifications', e.target.checked)}
            />
            <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-primary-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-primary-600"></div>
          </label>
        </div>
      </div>
    </div>
  );

  const renderAppearanceSettings = () => (
    <div className="space-y-6">
      <h3 className="text-lg font-medium text-gray-900">Внешний вид</h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Основной цвет
          </label>
          <div className="flex items-center space-x-3">
            <input
              type="color"
              className="w-12 h-12 rounded-lg border border-gray-300"
              value={settings.primary_color}
              onChange={(e) => handleInputChange('primary_color', e.target.value)}
            />
            <input
              type="text"
              className="input-field flex-1"
              value={settings.primary_color}
              onChange={(e) => handleInputChange('primary_color', e.target.value)}
            />
          </div>
        </div>
        
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Дополнительный цвет
          </label>
          <div className="flex items-center space-x-3">
            <input
              type="color"
              className="w-12 h-12 rounded-lg border border-gray-300"
              value={settings.secondary_color}
              onChange={(e) => handleInputChange('secondary_color', e.target.value)}
            />
            <input
              type="text"
              className="input-field flex-1"
              value={settings.secondary_color}
              onChange={(e) => handleInputChange('secondary_color', e.target.value)}
            />
          </div>
        </div>
      </div>
      
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Логотип ресторана
        </label>
        <input
          type="file"
          accept="image/*"
          className="input-field"
          onChange={(e) => {
            // Здесь будет логика загрузки файла
            console.log('Загрузка файла:', e.target.files[0]);
          }}
        />
        <p className="text-sm text-gray-500 mt-1">
          Рекомендуемый размер: 200x200px, формат PNG или JPG
        </p>
      </div>
      
      <div className="p-4 bg-gray-50 rounded-lg">
        <h4 className="font-medium text-gray-900 mb-2">Предварительный просмотр</h4>
        <div className="flex items-center space-x-4">
          <div 
            className="w-16 h-16 rounded-lg flex items-center justify-center text-white font-bold"
            style={{ backgroundColor: settings.primary_color }}
          >
            PWA
          </div>
          <div 
            className="px-4 py-2 rounded-lg font-medium"
            style={{ 
              backgroundColor: settings.secondary_color,
              color: settings.primary_color 
            }}
          >
            Кнопка
          </div>
        </div>
      </div>
    </div>
  );

  const renderTabContent = () => {
    switch (activeTab) {
      case 'general':
        return renderGeneralSettings();
      case 'delivery':
        return renderDeliverySettings();
      case 'payment':
        return renderPaymentSettings();
      case 'notifications':
        return renderNotificationSettings();
      case 'appearance':
        return renderAppearanceSettings();
      default:
        return renderGeneralSettings();
    }
  };

  return (
    <div className="space-y-6">
      {/* Заголовок */}
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-3xl font-bold text-gray-900">Настройки</h1>
          <p className="text-gray-600 mt-1">Управляйте настройками ресторана</p>
        </div>
        <button
          onClick={handleSave}
          disabled={loading}
          className="btn-primary"
        >
          {loading ? 'Сохранение...' : 'Сохранить изменения'}
        </button>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
        {/* Боковое меню */}
        <div className="lg:col-span-1">
          <nav className="space-y-1">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`w-full flex items-center px-3 py-2 text-sm font-medium rounded-lg transition-colors ${
                  activeTab === tab.id
                    ? 'bg-primary-500 text-white'
                    : 'text-gray-600 hover:text-gray-900 hover:bg-gray-100'
                }`}
              >
                <span className="mr-3 text-lg">{tab.icon}</span>
                {tab.name}
              </button>
            ))}
          </nav>
        </div>

        {/* Основной контент */}
        <div className="lg:col-span-3">
          <div className="card">
            {renderTabContent()}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Settings; 